<footer class="app-footer">
  <p class="app-footer__copyright">
    &#169;{{currentYear}} Eurofins Clinical Diagnostics US | {{version}}
  </p>
  <nav class="app-footer__navigation">
      <ul>
           <span class="p-r-4">|</span>
          <li>
              <a routerLink='/contact-support' class="simple-link">Contact Support</a>
          </li>
          <span>|</span>
          <li>
              <a routerLink='/terms-of-use' class="simple-link">Terms of Use</a>
          </li>
          <span>|</span>
          <li>
              <a routerLink='/privacy-policy' class="simple-link">Privacy Policy</a>
          </li>
      </ul>
  </nav>
</footer>
